import { boolean, object } from 'zod';

export const OrderAheadOnlyConstraintSchema = object({
  isEnabled: boolean(),
});
